import {SHOW_POPUP, HIDE_POPUP} from '@/store/mutation-types'

const state = {
	show: false,
	data: null,
	action: null,
	type: null,
	id: null,
	specification: null,
	message: null
}

const getters = {
	hasPopup: state => state.show,
	popupData: state => state.data,
	popupId: state => state.id,
	popupType: state => state.type,
	popupAction: state => state.action,
	popupMessage: state => state.message,
	popupSpecification: state => state.specification
}

const actions = {
	[SHOW_POPUP]: ({commit, dispatch}, data) => {
		return new Promise((resolve, reject) => {
			commit(SHOW_POPUP, data)
			resolve()
		})
	},
	[HIDE_POPUP]: ({commit, dispatch}) => {
		return new Promise((resolve, reject) => {
			commit(HIDE_POPUP)
			resolve()
		})
	}
}

const mutations = {
	[SHOW_POPUP]: (state, data) => {
		state.show = true
		state.data = data
		state.id = data.id !== undefined ? data.id : null
		state.type = data.type !== undefined ? data.type : null
		state.action = data.action !== undefined ? data.action : null
		state.specification = data.specification !== undefined ? data.specification : null
		state.message = data.message !== undefined ? data.message : null
	},
	[HIDE_POPUP]: (state) => {
		state.show = false
		state.data = null
		state.id = null
		state.type = null
		state.action = null
		state.specification = null
		state.message = null
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/popup.js